// extracted by extract-css-chunks-webpack-plugin
module.exports = {"subtitle":"subtitle_zoSoj mb-[1em] text-xs text-black-light lg_text-[0.9rem]","list":"list_CPqYC flex flex-wrap text-[0.9rem]","item":"item_u4kMl mb-[0.5em] w-1/3"};